import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AGGridUTCTOLocalDateService {

  public gridApi: any;

  constructor() { }
 // arr: any[]
  excelExport(params:any)  {
    
    params.processCellCallback = function (cellParams: any) {
    
      if (
        (cellParams && cellParams.column.colDef.type === 'date'))
        return cellParams.value !== null
          ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A')
          : '';
        
       return cellParams.value ;// no formatting
    
  
}
  }
excelExportDate(params:any)  {
    
  params.processCellCallback = function (cellParams: any) {
  
    if (
      (cellParams && cellParams.column.colDef.type === 'date'))
      return cellParams.value !== null
        ? moment(cellParams.value).format('MM/DD/YYYY')
        : '';
      
     return cellParams.value ;// no formatting
  }
  // return  this.gridApi.exportDataAsExcel(params);
  }
 
  excelExportDateTime(params:any)  {
    
    params.processCellCallback = function (cellParams: any) {
    
      if (
        (cellParams && cellParams.column.colDef.type === 'date'))
        return cellParams.value !== ''
          ? moment(cellParams.value).format('MM/DD/YYYY HH:mm')
          : '';
        
       return cellParams.value ;// no formatting
    }
    // return  this.gridApi.exportDataAsExcel(params);
    }


  csvExport(params:any){
    
    params.processCellCallback = function (cellParams: any) {
    
      if (
        (cellParams && cellParams.column.colDef.type === 'date'))
        return cellParams.value !== null
          ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A')
          : '';
      
       return cellParams.value // no formatting
    }
    //this.gridApi.exportDataAsCsv(params)
    // var params = {
    //   fileName: 'Input-report',
    // }
    // this.gridApi.exportDataAsCsv(params);
  }

  csvExportDateTime(params:any){
    
    params.processCellCallback = function (cellParams: any) {
    
      if (
        (cellParams && cellParams.column.colDef.type === 'date'))
        return cellParams.value !== ''
          ? moment(cellParams.value).format('MM/DD/YYYY HH:mm')
          : '';
      
       return cellParams.value // no formatting
    }
  }


  csvExportDate(params:any){
    
    params.processCellCallback = function (cellParams: any) {
    
      if (
        (cellParams && cellParams.column.colDef.type === 'date'))
        return cellParams.value !== null
          ? moment(cellParams.value).format('MM/DD/YYYY')
          : '';
      
       return cellParams.value // no formatting
    }
    //this.gridApi.exportDataAsCsv(params)
    // var params = {
    //   fileName: 'Input-report',
    // }
    // this.gridApi.exportDataAsCsv(params);
  }


}
